<template>
    <div class="card_container">
        <img :src="noDataImage" alt="">
        <div class="main_text">
            {{noDataText}}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps<{
    image?: string,
    text?: string
}>()

const noDataImage = computed(() => {
    return props.image || require('@/assets/themeFour/n1.png')
})
const noDataText = computed(() => {
    return props.text || t('common.noRecords')
})
</script>
<style scoped>
.card_container {
    padding: 35px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

}

.card_container img {
    width: 150px;
}

.main_text {
    color: rgba(255, 255, 255, 0.2);
    font-size: 14px;
    padding: 15px;
    font-weight: 500;
    display: flex;
    justify-content: center;
}
</style>